export const GaConfigure = {
  trackingId: process.env.REACT_APP_GA_TRACKING_ID || "G-HZ7BVK8YFM",
};
